var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.7963,
    height: 11.9259,
    rx: 2.55556,
    transform: "matrix(-1 0 0 1 9.79639 7.42603)",
    fill: "#7A67FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19 16.4444C19 17.8558 17.8558 19 16.4444 19H6C5.20435 19 4.44129 18.6839 3.87868 18.1213C3.31607 17.5587 3 16.7956 3 16V3.55556C3 2.14416 4.14416 1 5.55556 1H16C16.7956 1 17.5587 1.31607 18.1213 1.87868C18.6839 2.44129 19 3.20435 19 4V16.4444Z",
    fill: "url(#paint0_linear_7041_515)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.62 5C10.905 5 11.18 5.1 11.43 5.32L11.524 5.408L14.089 8.545C14.222 8.707 14.329 8.884 14.409 9.069H16.17C16.3615 9.0686 16.546 9.14151 16.6855 9.27278C16.825 9.40404 16.909 9.58371 16.9202 9.77493C16.9315 9.96615 16.8691 10.1544 16.746 10.3012C16.6228 10.4479 16.4482 10.5419 16.258 10.564L16.17 10.569H14.51C14.441 10.811 14.33 11.044 14.179 11.256L14.087 11.376L11.368 14.673C11.17 14.873 10.91 14.996 10.633 15.023L10.513 15.03H6.10996C5.9184 15.0304 5.73396 14.9575 5.59445 14.8262C5.45495 14.695 5.37095 14.5153 5.3597 14.3241C5.34844 14.1328 5.41078 13.9446 5.53392 13.7978C5.65706 13.6511 5.83168 13.5571 6.02196 13.535L6.10996 13.53H10.37L12.928 10.423C13.0253 10.3047 13.083 10.1589 13.093 10.006C13.1031 9.85316 13.0649 9.70102 12.984 9.571L12.93 9.495L10.484 6.5H6.10896C5.92525 6.50004 5.74792 6.43266 5.6106 6.31064C5.47327 6.18862 5.38551 6.02044 5.36396 5.838L5.35896 5.751C5.35891 5.5673 5.42629 5.38996 5.54832 5.25264C5.67034 5.11532 5.83852 5.02755 6.02096 5.006L6.10896 5.001H10.62V5ZM9.96595 9.068C10.1575 9.0676 10.342 9.14051 10.4815 9.27178C10.621 9.40304 10.705 9.58271 10.7162 9.77393C10.7275 9.96515 10.6651 10.1534 10.542 10.3002C10.4188 10.4469 10.2442 10.5409 10.054 10.563L9.96595 10.568H6.10996C5.9184 10.5684 5.73396 10.4955 5.59445 10.3642C5.45495 10.233 5.37095 10.0533 5.3597 9.86207C5.34844 9.67085 5.41078 9.48257 5.53392 9.33585C5.65706 9.18912 5.83168 9.09508 6.02196 9.073L6.10996 9.068H9.96696H9.96595Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7041_515",
    x1: 3,
    y1: 10,
    x2: 19,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon10);
export default __webpack_public_path__ + "static/media/navicon10.2877d8d37853da2f345225a483e542ac.svg";
export { ForwardRef as ReactComponent };